import React from "react";
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
} from "@chakra-ui/react";
import CourseSilabusEdit from "../components/courseComponents/CourseSilabusEdit";
import CourseUmumEdit from "../components/courseComponents/CourseUmumEdit";
import CourseManfaatEdit from "./CourseManfaatEdit";

export default function CourseUpdateForm() {
  return (
    <VStack align={"stretch"} gap={0} flex={1}>
      <Tabs
        position="relative"
        // variant={"unstyled"}
        w={"100%"}
        colorScheme="ap"
        flex={1}
      >
        <TabList
          borderBottom={"1px solid var(--divider3)"}
          color={"p.500"}
          h={"50px"}
          bg={"whiteAlpha.900"}
          backdropFilter={"blur(5px)"}
          mx={"auto"}
          justifyContent={"center"}
          zIndex={96}
          px={5}
          // pl={"calc(60px + 16px)"}
          w={"100%"}
        >
          <Tab fontWeight={500} h={"50px"} mb={"1px"}>
            Umum
          </Tab>
          <Tab fontWeight={500} h={"50px"} mb={"1px"}>
            Kurikulum
          </Tab>
          <Tab fontWeight={500} h={"50px"} mb={"1px"}>
            Manfaat
          </Tab>
        </TabList>

        <TabPanels flex={1} as={VStack} align={"stretch"}>
          <TabPanel flex={1} p={0}>
            <CourseUmumEdit />
          </TabPanel>

          <TabPanel flex={1} p={0}>
            <CourseSilabusEdit />
          </TabPanel>

          <TabPanel flex={1} p={0}>
            <CourseManfaatEdit />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
}
